import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { Observable, of } from 'rxjs';
import { ExamService } from 'src/app/services/exam-service.service';
import { id } from 'date-fns/locale';

@Injectable( {
  providedIn: 'root'
} )
export class ExamDetailsService {

  opOpen$: Observable<boolean> = of( false );
  constructor ( private router: Router, private examService: ExamService ) { }


  async processCandidateOperation ( route: any, origin: any ) {

    // if (route == 'candidate/view') {
    //   this.router.navigate(['candidates/view'])
    // }
    this.router.navigate( [ route ] );
  }


  public examDetailsList () {
    return [
      {
        icon: 'mat:calendar_today',
        label: 'Schedule',
        route: `/exams/${ this.examService.selectedExamIds }/schedules`,
        id:'examinations_examination_schedules'
      },
  
      // {
      //   icon: 'mat:calendar_today',
      //   label: 'Exam Penalties',
      //   route: `/exams/${ this.examService.selectedExamIds }/exampenalties`,
      //   id:''
      // },
      {
        icon: 'mat:assignment',
        label: 'View Questions',
        route: `/exams/${ this.examService.selectedExamIds }/questions`,
        id:'examinations_view_questions'
      },
      {
        icon: 'mat:all_out',
        label: 'Proctors',
        route: `/exams/${ this.examService.selectedExamIds }/proctors`,
        id:'examinations_proctors'
      },
      {
        icon: 'mat:contacts',
        label: 'Essay Exam Log',
        route: `/exams/${ this.examService.selectedExamIds }/essayexamlog`,
        id:'examinations_essay_exam_log'
      },
      {
        icon: 'mat:assessment',
        label: 'Extra field labels',
        route: `/exams/${ this.examService.selectedExamIds }/extrafields`,
        id:'examinations_extra_fields_label'
      },
      {
        icon: 'mat:contacts',
        label: 'View Tickets',
        route: `/complaints/exam/${ this.examService.selectedExamIds }`,
        id:'examinations_view_complaints'
      },
      {
        icon: 'mat:group_add',
        label: 'Exam Examiners',
        route: `/exams/examiners`,  
        id:'examinations_exam_examiners'
      },
      {
        icon: 'mat:assignment',
        label: 'Update SAQ Possible Answers',
        route: `/exams/${ this.examService.selectedExamIds }/updatesaqanswers`,
        id:'update_saq_possible_answers'
      },
      {
        icon: 'mat:account_balance',
        label: 'Exam Question Banks',
        route: `/exams/${ this.examService.selectedExamIds }/questionbanks`,
        id:'examinations_question_banks'
      },
    ];
  }
}
